/*
 * Copyright Camunda Services GmbH and/or licensed to Camunda Services GmbH under
 * one or more contributor license agreements. See the NOTICE file distributed
 * with this work for additional information regarding copyright ownership.
 * Licensed under the Camunda License 1.0. You may not use this file
 * except in compliance with the Camunda License 1.0.
 */

import { Play } from 'icons';

import * as Styled from './DeploymentActions.styled';

export default function StartInstanceButton({ onExecute, runButtonTitle, isRunDisabled }) {
  return (
    // @ts-expect-error TS2769
    <Styled.PrimaryButton
      data-test="start-instance-button"
      size="small"
      onClick={onExecute}
      title={runButtonTitle}
      disabled={isRunDisabled}
    >
      <Play />
      Run
    </Styled.PrimaryButton>
  );
}
